const currentENV = process.env.REACT_APP_ENV;
const athenaUrls = {
  DEV: "https://ummo-dev.kantar.com/athena/",
  QA: "https://ummo-qa.kantar.com/athena/",
  UAT: "https://ummo-uat.kantar.com/athena/",
  PREPROD: "https://ummo-preprod.kantar.com/athena/",
  HOTFIX: "https://ummo-hotfix.kantar.com/athena/",
  ARCHIVE: "https://ummo-archive.kantar.com/athena/",
  DEMO: "https://ummo-demo.kantar.com/athena/",
  PROD: "https://ummo.kantar.com/athena/",
  DEFAULT: "https://ummo.kantar.com/athena/",
};

const haiUrls = {
  DEV: "https://ummo-dev.kantar.com/hai/",
  QA: "https://ummo-qa.kantar.com/hai/",
  UAT: "https://ummo-uat.kantar.com/hai/",
  PREPROD: "https://ummo-preprod.kantar.com/hai/",
  HOTFIX: "https://ummo-hotfix.kantar.com/hai/",
  ARCHIVE: "https://ummo-archive.kantar.com/hai/",
  DEMO: "https://ummo-demo.kantar.com/hai/",
  PROD: "https://ummo.kantar.com/hai/",
  DEFAULT: "https://ummo.kantar.com/hai/",
};

const UMMOConfig = {
  text: {
    UMMOHeading: "Unified Marketing Measurement & Optimization",
    UMMODescription: "Enabling agile and dynamic marketing decisions and budget allocation",
    buttonText: "Log in",
  },
  products: [
    {
      key: "athena",
      name: "Athena",
      description: "Strategic optimisation of marketing mix on business performance",
      imageSrc: "/images/athena-image.png",
      link: athenaUrls[currentENV] ?? athenaUrls["DEFAULT"],
      accentColor: "#AA8A30",
    },
    {
      key: "hai",
      name: "Hamilton.AI",
      description: "Strategic and tactical optimisation of marketing mix on business performance",
      imageSrc: "/images/hai-image.png",
      link: haiUrls[currentENV] ?? haiUrls["DEFAULT"],
      accentColor: "#802AB5",
    },
  ],
};

export default UMMOConfig;
